import React from 'react';

const ProductPrice = ({ children }) => {
  return <div className="flex flex-row gap-x-2 items-center">{children}</div>;
};

const Price = ({ children }) => {
  return <p className="text-xl text-gray-900">{children}</p>;
};

ProductPrice.Price = Price;

export default ProductPrice;
